import { FC } from 'react';
import { CourseInfo } from '../../types/apis/contentsListApi';
import { trainingMode } from '../../utils/training/trainingUtil';
import styles from './LessonContinuation.module.scss';

type Props = {
  number: string; // レッスン・トピック番号
  description: string; // 説明文
  trainingId: number; // トレーニングID
  contents: CourseInfo[]; // コンテンツ一覧
  onClickContinueButton: (trainingId: number, contents: CourseInfo[]) => void;
};

const LessonContinuation: FC<Props> = ({
  number,
  description,
  trainingId,
  onClickContinueButton,
  contents,
}) => (
  <>
    <footer className={styles['resume-footer']}>
      <div className={styles['footer-container']}>
        <div className={styles['footer-container-left']}>
          <div className={styles['lesson-number']}>{number}</div>
          <div className={styles['topic-title-outer']}>
            <p>{description}</p>
            <span className={styles['topic-type']}>
              {trainingMode(trainingId)}
            </span>
          </div>
        </div>
        <div className={styles['footer-container-right']}>
          <button
            type="button"
            className={`${styles['controller-view-btn']} ${styles['mod-large']}`}
            onClick={() => onClickContinueButton(trainingId, contents)}
          >
            <figure>
              <div
                className={`${styles['svg-icon']} ${styles['mod-64']} ${styles['ic-play-arrow']}`}
              />
            </figure>
          </button>
        </div>
      </div>
    </footer>
  </>
);
export default LessonContinuation;
